module.exports = __webpack_public_path__ + "img/1002.0622c9c2.jpg";